import type { IAppConfigFlavor } from "../types/app-config";

// NOTE: NSAI-1606 — the brand a client falls back to when /app-config sends no
// readable flavor: the default build's own.
export const APP_CONFIG_DEFAULT_FLAVOR: IAppConfigFlavor = {
  key: "nodeshift",
  appName: "NodeShift AI",
  companyName: "NodeShift",
  defaultLanguage: "en",
};
